"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo, useState } from "react";
import ImageGallery from "@modules/products/components/image-gallery";
import VirtualTryOnDrawer from "@modules/products/components/virtual-try-on";
const ProductMedia = t0 => {
  const $ = _c(18);
  const {
    product
  } = t0;
  const [virtualTryOnOpen, setVirtualTryOnOpen] = useState(false);
  const isVirtualTryOnEnabled = Boolean(product?.virtualTryOnEnabled && Array.isArray(product?.images) && product.images.length > 0);
  let t1;
  if ($[0] !== isVirtualTryOnEnabled) {
    t1 = () => {
      if (isVirtualTryOnEnabled) {
        setVirtualTryOnOpen(true);
      }
    };
    $[0] = isVirtualTryOnEnabled;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleOpenVirtualTryOn = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setVirtualTryOnOpen(false);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleCloseVirtualTryOn = t2;
  let t3;
  if ($[3] !== product?.images) {
    t3 = product?.images || [];
    $[3] = product?.images;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = product?.videoUrl;
  let t5;
  if ($[5] !== handleOpenVirtualTryOn || $[6] !== isVirtualTryOnEnabled || $[7] !== product || $[8] !== t3 || $[9] !== t4) {
    t5 = <ImageGallery images={t3} product={product} videoUrl={t4} virtualTryOnEnabled={isVirtualTryOnEnabled} onVirtualTryOn={handleOpenVirtualTryOn} />;
    $[5] = handleOpenVirtualTryOn;
    $[6] = isVirtualTryOnEnabled;
    $[7] = product;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== isVirtualTryOnEnabled || $[12] !== product || $[13] !== virtualTryOnOpen) {
    t6 = isVirtualTryOnEnabled && <VirtualTryOnDrawer open={virtualTryOnOpen} onClose={handleCloseVirtualTryOn} product={product} />;
    $[11] = isVirtualTryOnEnabled;
    $[12] = product;
    $[13] = virtualTryOnOpen;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t5 || $[16] !== t6) {
    t7 = <>{t5}{t6}</>;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};
export default ProductMedia;